// Region index — maps every appellation in /lib/appellations.js to a wine
// region. The visible region names are i18n'd via the keys below; the
// `labelKey` lets the page resolve the localised name at render time.
//
// Order in REGIONS controls the display order on the hub.
export const REGIONS = [
  { id: "bordeaux",     labelKey: "cartes.region.bordeaux" },
  { id: "bourgogne",    labelKey: "cartes.region.bourgogne" },
  { id: "beaujolais",   labelKey: "cartes.region.beaujolais" },
  { id: "rhone",        labelKey: "cartes.region.rhone" },
  { id: "loire",        labelKey: "cartes.region.loire" },
  { id: "champagne",    labelKey: "cartes.region.champagne" },
  { id: "languedoc",    labelKey: "cartes.region.languedoc" },
  { id: "provence",     labelKey: "cartes.region.provence" },
  { id: "jura",         labelKey: "cartes.region.jura" },
  { id: "italy",        labelKey: "cartes.region.italy" },
  { id: "spain",        labelKey: "cartes.region.spain" },
  { id: "portugal",     labelKey: "cartes.region.portugal" },
];
export const OTHER_REGION_LABEL_KEY = "cartes.region.other";

// Appellation → region id. Anything missing falls into "other" which we
// surface as "Autres terroirs" — better than dropping the card entirely.
export const APPELLATION_REGION = {
  // Bordeaux & Sud-Ouest
  "Bordeaux": "bordeaux", "Médoc": "bordeaux", "Pauillac": "bordeaux", "Margaux": "bordeaux",
  "Saint-Estèphe": "bordeaux", "Saint-Julien": "bordeaux", "Pessac-Léognan": "bordeaux",
  "Graves": "bordeaux", "Sauternes": "bordeaux", "Barsac": "bordeaux",
  "Saint-Émilion": "bordeaux", "Pomerol": "bordeaux", "Fronsac": "bordeaux",
  "Côtes de Bourg": "bordeaux", "Cadillac": "bordeaux",
  "Cahors": "bordeaux", "Madiran": "bordeaux", "Jurançon": "bordeaux", "Irouléguy": "bordeaux",
  "Buzet": "bordeaux", "Bergerac": "bordeaux", "Monbazillac": "bordeaux",
  // Bourgogne
  "Chablis": "bourgogne", "Mâcon": "bourgogne", "Pouilly-Fuissé": "bourgogne", "Saint-Véran": "bourgogne",
  "Côte de Nuits": "bourgogne", "Gevrey-Chambertin": "bourgogne", "Vosne-Romanée": "bourgogne",
  "Nuits-Saint-Georges": "bourgogne", "Chambolle-Musigny": "bourgogne", "Morey-Saint-Denis": "bourgogne",
  "Côte de Beaune": "bourgogne", "Meursault": "bourgogne", "Puligny-Montrachet": "bourgogne",
  "Chassagne-Montrachet": "bourgogne", "Pommard": "bourgogne", "Volnay": "bourgogne",
  "Beaune": "bourgogne", "Aloxe-Corton": "bourgogne",
  // Beaujolais
  "Beaujolais": "beaujolais", "Brouilly": "beaujolais", "Fleurie": "beaujolais",
  "Morgon": "beaujolais", "Moulin-à-Vent": "beaujolais", "Chiroubles": "beaujolais",
  "Juliénas": "beaujolais", "Saint-Amour": "beaujolais", "Côte de Brouilly": "beaujolais",
  "Régnié": "beaujolais", "Chénas": "beaujolais",
  // Rhône
  "Côte-Rôtie": "rhone", "Condrieu": "rhone", "Saint-Joseph": "rhone", "Hermitage": "rhone",
  "Crozes-Hermitage": "rhone", "Cornas": "rhone", "Saint-Péray": "rhone",
  "Châteauneuf-du-Pape": "rhone", "Gigondas": "rhone", "Vacqueyras": "rhone",
  "Lirac": "rhone", "Tavel": "rhone", "Côtes du Rhône": "rhone",
  // Loire
  "Sancerre": "loire", "Pouilly-Fumé": "loire", "Menetou-Salon": "loire", "Quincy": "loire",
  "Reuilly": "loire", "Touraine": "loire", "Vouvray": "loire", "Chinon": "loire",
  "Bourgueil": "loire", "Saumur": "loire", "Saumur-Champigny": "loire",
  "Anjou": "loire", "Savennières": "loire", "Coteaux du Layon": "loire",
  "Bonnezeaux": "loire", "Muscadet": "loire",
  // Champagne & Alsace
  "Champagne": "champagne", "Crémant d'Alsace": "champagne", "Crémant de Loire": "champagne",
  "Crémant de Bourgogne": "champagne", "Alsace": "champagne",
  // Languedoc-Roussillon
  "Languedoc": "languedoc", "Corbières": "languedoc", "Minervois": "languedoc",
  "Picpoul de Pinet": "languedoc", "Saint-Chinian": "languedoc", "Faugères": "languedoc",
  "Pic Saint-Loup": "languedoc", "Limoux": "languedoc", "Blanquette de Limoux": "languedoc",
  "Côtes du Roussillon": "languedoc", "Maury": "languedoc", "Banyuls": "languedoc",
  "Rivesaltes": "languedoc", "Collioure": "languedoc", "Montpeyroux": "languedoc",
  // Provence & Corse
  "Côtes de Provence": "provence", "Bandol": "provence", "Cassis": "provence",
  "Bellet": "provence", "Coteaux d'Aix-en-Provence": "provence",
  "Patrimonio": "provence", "Ajaccio": "provence", "Vin de Corse": "provence",
  // Jura & Savoie
  "Arbois": "jura", "Château-Chalon": "jura", "Côtes du Jura": "jura", "L'Étoile": "jura",
  "Vin de Savoie": "jura", "Roussette de Savoie": "jura",
  // Italie
  "Barolo": "italy", "Barbaresco": "italy", "Chianti": "italy",
  "Brunello di Montalcino": "italy", "Vino Nobile di Montepulciano": "italy",
  "Amarone della Valpolicella": "italy", "Soave": "italy",
  "Prosecco": "italy", "Franciacorta": "italy", "Etna": "italy", "Taurasi": "italy",
  // Espagne
  "Rioja": "spain", "Ribera del Duero": "spain", "Priorat": "spain", "Rías Baixas": "spain",
  "Jerez": "spain", "Cava": "spain", "Toro": "spain", "Bierzo": "spain", "Rueda": "spain",
  // Portugal
  "Douro": "portugal", "Porto": "portugal", "Vinho Verde": "portugal", "Dão": "portugal",
  "Alentejo": "portugal", "Bairrada": "portugal", "Madeira": "portugal",
};
